<template>
  <div
	id="g-recaptcha"
	class="g-recaptcha"
	:data-sitekey="sitekey">
  </div>
</template>

<script>
export default {
	data() {
		return {
			sitekey: process.env.VUE_APP_GOOGLE_RECAPTCHA_SITE_KEY ?? '6Lc1IlMlAAAAAMAAZaCaXqn_0ddb_XPe62XdLuhG',
			widgetId: 0,
		};
	},
	methods: {
		// execute() {
		// 	window.grecaptcha.execute(this.widgetId);
		// },
		// reset() {
		// 	window.grecaptcha.reset(this.widgetId);
		// },
		// render() {
		// 	if (window.grecaptcha) {
		// 		this.widgetId = window.grecaptcha.render('g-recaptcha', {
		// 			sitekey: this.sitekey,
		// 			size: 'normal',
		// 			// the callback executed when the user solve the recaptcha
		// 			callback: (response) => {
		// 				// emit an event called verify with the response as payload
		// 				this.$emit('verify', response);
		// 				// reset the recaptcha widget so you can execute it again
		// 				this.reset();
		// 			},
		// 		});
		// 	}
		// },
		loadRecaptcha() {
			const recaptchaScript = document.createElement('script');
			recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js');
			document.head.appendChild(recaptchaScript);
		},
	},
	mounted() {
		// render the recaptcha widget when the component is mounted
		// this.render();
		this.loadRecaptcha();
	},
};
</script>
